import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type {
	AiSuggestionsPlugin,
	Suggestion,
} from '../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../pm-plugins/main';
import { applySuggestion } from '../ui/utils/applySuggestion';

import type { AcceptSuggestionAction } from './types';

export const acceptSuggestionAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => AcceptSuggestionAction = (api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(id: string): boolean => {
		let suggestion: Suggestion | undefined;
		api?.core?.actions.execute(({ tr }) => {
			suggestion = api?.aiSuggestions?.sharedState.currentState()?.suggestionById.get(id);
			if (!suggestion) {
				return tr;
			}
			tr.setMeta(aiSuggestionsPluginKey, { action: 'REMOVE_SUGGESTION', id });
			api?.showDiff?.commands.hideDiff?.({ tr });
			return tr;
		});
		if (!suggestion) {
			return false;
		}
		applySuggestion({ api, suggestion });
		return true;
	};
